import { useState } from 'react';
import Box from '@mui/material/Box';
import Close from '@mui/icons-material/Close';
import ExpandMore from '@mui/icons-material/ExpandMore';
import ExpandLess from '@mui/icons-material/ExpandLess';
import IconButton from '@mui/material/IconButton';
import UnitDetailContext from './UnitDetailContext';
import { Trans } from 'react-i18next';
import { useNavigate } from "react-router-dom";

function ExpandedItem(props: {i18nKey: string, value: string}) {
  return (
    <Box className="unit-detail-expanded-item" mb={2}>
      <Box className="unit-detail-expanded-item-key"><Trans i18nKey={props.i18nKey}/></Box>
      <Box className="unit-detail-expanded-item-value">{props.value || '-'}</Box>
    </Box>
  )
}

export default function(props: {isLogged: Boolean}) {
  const navigate = useNavigate();
  const [expanded, setExpanded] = useState(false)

  const handleClose = () => {
    navigate(`/web/search-vehicles`, { replace: true })
  }

  const openUnit = (numberPlate: string) => {
    if(numberPlate !== '' && numberPlate !== null) {
      navigate(`/web/unit/${numberPlate}`)
    }
  }

  return (
    <UnitDetailContext.Consumer>
      { context => {
        return (
          <Box className='unit-detail-main-section'>
            <IconButton onClick={handleClose} className='search-vehicles-icon-button unit-detail-floating-button'
            sx={{
              transform: {xs: 'translate(0, -75%)', sm: 'translate(435px, -75%)', md: 'translate(435px, -75%)', lg: 'translate(435px, -75%)', xl: 'translate(435px, -75%)'},
              right: {xs: '8%', sm: 'initial', md: 'initial', lg: 'initial', xl: 'initial'},
            }}>
              <Close />
            </IconButton>
            <Box className='unit-detail-number-plate'>{context.unit.numberPlate}</Box>
            <Box className='unit-detail-car-classification'>
              {context.unit.unitType?.model ?? "-"}
            </Box>
            <Box sx={{display: 'flex', justifyContent: 'space-around'}}>
              <Box className='unit-detail-model'>{`${context.unit.unitType.brand} - ${context.unit.color}`}</Box>
            {props.isLogged &&(<IconButton className='unit-detail-floating-expand' onClick={() => setExpanded(!expanded)}>
                {!expanded && <ExpandMore />}
                {expanded && <ExpandLess />}
              </IconButton>)}  
            </Box>
            {expanded &&
              <Box className="unit-detail-expanded">
                <ExpandedItem i18nKey={`screens.unitDetail.chassisId`} value={context.unit.chassisID} />
                <ExpandedItem i18nKey={`screens.unitDetail.engineId`} value={context.unit.engineID} />
                <ExpandedItem i18nKey={`screens.unitDetail.status`} value={context.unit.unitStatus} />
                <ExpandedItem i18nKey={`screens.unitDetail.enterprise`} value={context.unit.contract?.company?.name} />
                <Box className="unit-detail-expanded-item">
                  <Box className="unit-detail-expanded-item-key"><Trans i18nKey={`screens.unitDetail.contractId`}/></Box>
                  <Box className="unit-detail-expanded-item-value" onClick={()=>openUnit(context.unit.numberPlate)}><Box className="link-primary">{context.unit.contract?.idContract || '-'}</Box></Box>
                </Box>
              </Box>
            }
          </Box>
        )
      }}
    </UnitDetailContext.Consumer>
  );
}